import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  name: "",
  selectedTasks: [],
  activeCallbacks: [],
  fetchingActiveCallbacks: false,
  displayActiveTasks: false,
  perPage: 15,
  labelIds: [],
};

if (localStorage.getItem("dashboard-tasks-label-ids") !== null
    && localStorage.getItem("dashboard-tasks-label-ids") !== "[]") {
  state.labelIds = JSON.parse(localStorage.getItem("dashboard-tasks-label-ids") || null);
}

if (localStorage.getItem("dashboard-tasks-per-page") !== null
    && Number.isInteger(parseInt(localStorage.getItem("dashboard-tasks-per-page"), 10))) {
  state.perPage = parseInt(localStorage.getItem("dashboard-tasks-per-page"), 10);
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
